import axios from '../../axios'

/*
 * 一分一段表数据接口
 */

// 获取一分一段表列表
export const getSegmentList = (data) => {
    return axios({
        url: '/api/data/wish/base/segment',
        method: 'get',
        data
    })
}

// 新增一分一段表信息
export const saveSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment',
        method: 'post',
        data
    })
}

// 编辑一分一段表信息
export const updateSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment',
        method: 'put',
        data
    })
}

// 删除一分一段表列表
export const deleteSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment',
        method: 'delete',
        data
    })
}

// 导入一分一段列表
export const importSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/import_segment',
        method: 'post',
        data
    })
}

// 批量删除一分一段列表
export const deleteBatchSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/delete_batch_segment',
        method: 'delete',
        data
    })
}

// 升级一分一段
export const upgradeSegment = (data) => {
    return axios({
        url: '/api/data/wish/base/segment/upgrade',
        method: 'put',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/base/segment.js